export default {
  es: {
    guardar: "Guardar",
    volver: "< Volver",
    sin_definir: "Sin definir",
    guardar_datos: "Guardar datos",
    cancelar: "Cancelar",
    confirmar: "Confirmar",
    eliminar: "Eliminar",
    aceptar: "Aceptar",
    rechazar: "Rechazar",
    comenzar: "Comenzar",
    cerrar_sesion: "Cerrar sesión",
    ver_menos: "Ver menos",
    ver_mas: "Ver más",
    inicio: "Inicio",
    ver_detalles: "Ver detalles",
    guardar: "Guardar",
    guardar_contrasena: "Guardar contraseña",
    editar: "Editar",
    anadir: "Añadir",
    enviar: "Enviar",
    requerido: "Requerido",
    revisar: "Revisar",
    editar_oferta: "Editar",
    duplicar_oferta: "Duplicar oferta",
    cerrar_oferta: "Cerrar oferta",
    eliminar_oferta: "Elimina oferta",
    ver_como_candidato: "Ver como candidato",
    practicas: "Prácticas",
    empleo: "Empleo",
    ver: "Ver",
    enlaces: {
      politica_privacidad: "/politica-de-privacidad",
      politica_cookies: "/politica-de-cookies",
      login: "/login",
      solicitar_cuenta: "/solicitar-cuenta",
      registroalumno: "/registro",
      encuestas: "/informes",
      encuesta: "/informe",
      eventos: "/eventos",
      eventospublico: "/evento-publico",
      documentacion: "/documentacion",
      practicas_asignadas: "/practicas_asignadas",
      guiaOrientacion: "/guias-orientacion",
      ofertas_practicas: "/propuesta-practicas",
      ofertas_practicas_cfa: "/propuesta-practicas-cfa",
      ofertas_empleo: "/ofertas-empleo",
      cv: "/cv",
      vercv: "/ver-cv",
      mis_candidaturas: "/mis-candidaturas",
      mis_practicas: "/mis-practicas",
      orientacion: "/orientacion-laboral",
      propuesta_practicas: "/propuesta-practicas-con-candidato-preseleccionado",
      programapracticasactivos: "/programas-practicas-activos",
      solicitarcambiopracticas: "/solicitar-cambio-practicas",
      subirconvenio: "/subir-convenio-firmado",
      generarnuevoconvenio: "/nuevo-convenio-colaboracion",
      practicaseducacion: "/solicitudes-practicas-educacion",
      nueva_oferta: "/nueva-propuesta",
      editar_oferta: "/editar-propuesta",
      mi_empresa: "/mi-empresa",
      mi_perfil: "/mi-perfil",
      mis_ofertas: "/mis-propuestas",
      propuestas_candidato: "/propuestas-practicas-candidato-preseleccionado",
      mi_oferta: "/propuesta",
      programa_practicas: "/programa-practicas",
      visualizar_oferta: "/visor-oferta",
      restablecer_login: "/restablecer-login",
      restablecer_candidato: "/restablecer-candidato",
      setear_pass: "/establecer-login",
      proteccion_datos: "/proteccion-de-datos",
      acceso_saml: "/acceso",
      acceso_saml_empresa: "/accesoempresa",
      logout: "/logout",
      ayuda: "/ayuda",
      condicionespracticasuib: "/uib/condiciones-practicas",
      factura_proforma: "/factura-proforma"
    },
    encabezado: {
      home: "Bienvenid@",
      cv: "Mi currículum",
      cv_view: "Currículum del candidato",
      eventos: "Eventos",
      propuesta_practicas: "Nueva propuesta con candidato preseleccionado",
      politica_privacidad: "Política de privacidad",
      politica_cookies: "Política de cookies",
      login: "Inicio de sesión",
      solicitar_cuenta: "Nueva empresa",
      registro_alumno: "Registro",
      ofertas_practicas: "Listado de ofertas de prácticas",
      ofertas_practicas_cfa: "Listado de ofertas de formación en alternancia",
      ofertas_empleo: "Listado de ofertas de empleo",
      ficha_oferta_alumno_empleo: "Listado de ofertas de empleo",
      ficha_oferta_alumno_practicas: "Listado de ofertas de prácticas",
      mis_candidaturas: "Mis candidaturas",
      mis_practicas: "Mis prácticas",
      ficha_oferta_mis_practicas: "Mis prácticas",
      propuestasCandidadoPreseleccionado: "Propuestas de prácticas con candidato preseleccionado",
      encuestas: "Informes",
      orientacion: "Orientación laboral",
      nueva_oferta: "Nueva propuesta",
      editar_oferta: "Editar",
      mi_empresa: "Mi empresa",
      solicitarBaja: "Solicitud de baja",
      mi_perfil: "Mi perfil",
      documentacion: "Documentación",
      practicasAsignadas: "Prácticas asignadas",
      guiasOrientacion: "Guías Orientación",
      documentacion_empresa: "Documentación",
      documentacion_alumno: "Mi documentación",
      mis_ofertas: "Mis propuestas",
      propuestas_candidato: "Propuestas de prácticas con candidato preseleccionado",
      mi_oferta: "Mi propuesta",
      ficha_oferta_empresa: "Mi propuesta",
      restablecer_login: "Restablecer Contraseña",
      restablecer_candidato: "Restablecer Contraseña",
      programapracticasactivos: "Programas de prácticas activos",
      setear_pass: "Establecer Contraseña",
      proteccion_datos: "Protección de datos",
      visor_oferta: "Ver como alumno",
      fichaProgramaActivo: "Programas activos",
      solicitudCambioPracticas: "Solicitud cambio de prácticas",
      solicitudesEducacion: "Solicitudes ofertas educación",
      subirConvenioFirmado: "Subir convenio firmado",
      generarNuevoConvenio: "Solicitud de Convenio de Colaboración",
      ayuda: "Ayuda",
      condicionespracticasuib: "Condiciones prácticas",
      factura_proforma: "Factura Proforma"
    },
    ficha_oferta: {
      texto_programa_anadido:
        "Tienes este programa añadido a tu lista de programas informáticos"
    },
    formulario: {
      nombre: "Nombre",
      nombre_apellidos: "Nombre y apellidos",
      apellidos: "Apellidos",
      email: "Email",
      mensaje: "Mensaje",
      fecha_nacimiento: "Fecha de nacimiento",
      dia: "Día",
      mes: "Mes",
      anyo: "Año",
      area_interes: "Área de su interés",
      trabaja_actualmente: "¿Trabaja actualmente?",
      si: "Si",
      no: "No",
      carta_presentacion: "Carta de presentacion",
      meses: {
        Enero: "Enero",
        Febrero: "Febrero",
        Marzo: "Marzo",
        Abril: "Abril",
        Mayo: "Mayo",
        Junio: "Junio",
        Julio: "Julio",
        Agosto: "Agosto",
        Septiembre: "Septiembre",
        Octubre: "Octubre",
        Noviembre: "Noviembre",
        Diciembre: "Diciembre"
      },
      archivo_adjunto: "Adjuntar archivo",
      adjuntar_cv: "Adjuntar CV",
      introduce_mail: "Introduce tu email",
      pais: "País",
      telefono: "Teléfono",
      he_leido: "He leído y acepto la",
      y_acepto: "política de privacidad",
      enviar: "Enviar",
      enviado: "Enviado"
    },
    meses: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ],
    login: {
      iniciar_sesion: "Iniciar sesión",
      acceder: "Acceder",
      email: "Email",
      error_mail: "Por favor, indica tu email para logarte en el portal.",
      contrasena: "Contraseña",
      repetir_contrasena: "Repetir Contraseña",
      contrasena_olvidada: "He olvidado mi contraseña",
      introduce_email: "Introduce tu email",
      email_mal: "El email está mal formado",
      recuperar_pass: "Recuperar mi contraseña",
      aun_no_registrado: "¿Aún no estas registrado/a?",
      acceder_SSO: "ACCEDER SSO UNIVERSIDAD",
      indica_mail:
        "Por favor, indica tu <strong>{{$t('oferta.email')}}</strong> para logarte en el portal.",
      selecciona_empresa:
        "Por favor, selecciona la empresa con la que quieres logarte.",
      titulacion: "Titulación",
      tipo_formacion: "Tipo de formación academica",
      selecciona_formacion: "Selecciona un tipo de formación",
      registrarme: "Registrarme",
      deseo_recibir:
        "Deseo recibir comunicaciones relacionadas con orientación y servicios relacionados con la formación superior y la UIB.",
      popup_rgpd: {
        titulo: "",
        detalle:
          "El acceso, rectificación y cancelación de los datos, así como otros derechos, puede llevarse a cabo según puede ver en el siguiente ",
        enlace: "enlace.",
        boton: "Consiento, acceder"
      },
      restablecer_pass: {
        titulo: "Sigue los pasos para restablecer tu contraseña",
        intro: "La contraseña debe contener al menos 8 caracteres y un numero.",
        guardar: "Guardar"
      },
      seteo_pass: {
        titulo: "Sigue los pasos para establecer tu contraseña",
        intro: "La contraseña debe contener al menos 8 caracteres y un numero.",
        guardar: "Guardar"
      }
    },
    registro: {
      encabezado:
        "Cumplimenta el formulario a continuación para darte de alta en el sistema:",
      datos_usuario: "Datos del usuario de empresa",
      datos_personales: "Datos personales",
      nombre: "Nombre",
      apellidos: "Apellidos",
      DNI: "DNI/NIF/NIE",
      CIF: "CIF de la empresa",
      puesto: "Puesto / Cargo",
      departamento: "Departamento",
      telefono_1: "Teléfono 1",
      telefono_2: "Teléfono 2",
      email: "Email",
      sede: "Sede por defecto",
      cargo: "Cargo",
      idioma: "Idioma preferido de comunicación",
      tipo_contacto: "Tipo de Contacto",
      contrasena: "Contraseña",
      repetir_contrasena: "Repetir Contraseña",
      direccion: "Dirección",
      pais: "País",
      selecciona_pais: "-selecciona un país-",
      provincia: "Provincia",
      selecciona_provincia: "-Selecciona una provincia-",
      localidad: "Localidad",
      selecciona_localidad: "-Selecciona una localidad-",
      direccion: "Dirección",
      direccion_empresa: "Dirección Empresa",
      cp: "Código Postal",
      titulo_2:
        "A continuación introduce los datos de tu empresa para darte de alta en el sistema:",
      anadir_imagen: "Haz click para añadir la imagen",
      autorizar_logo: "Autorizar uso del logo",
      nombre_fiscal: "Nombre fiscal o Razón social",
      nombre_comercial: "Nombre comercial",
      tipo_sociedad: "Tipo de Sociedad",
      selecciona_tipo_sociedad: "-Selecciona tipo de sociedad-",
      tipo_empresa: "Tipo de Empresa",
      privada: "Privada",
      publica: "Pública",
      startup: "Startup",
      eliminar: "Eliminar",
      descripcion: "Descripción",
      si: "Sí",
      no: "No",
      sector: "Sector",
      selecciona_sector: "-Selecciona un sector-",
      otro_sector: "Otro Sector",
      numero_empleados: "Número de empleados",
      selecciona_empleados: "-Selecciona un rango-",
      web: "Web",
      iban: "Número cuenta IBAN",
      descripcion_empresa: "Descripción de la empresa",
      femenino: "Femenino",
      masculino: "Masculino",
      telefono: "Teléfono",
      centrosTrabajo: "Centro de trabajo o sucursales",
      firmante: {
        titulo:
          "A continuación introduce los datos del representante legal de la empresa que firmará los convenios:",
        nombre: "Nombre del firmante",
        apellidos: "Apellidos del firmante",
        email: "Email del firmante",
        dni: "DNI del firmante",
        cargo: "Cargo del firmante",
        telefono: "Teléfono"
      },
      envio_facturas: {
        titulo: "Dirección envío de facturas",
        titulo_2: "Dirección de facturación"
      },
      anadir_direccion: "Añadir nueva dirección de facturación",
      perfil_sectorial: "Perfil sectorial",
      sector_actividad: "Sector de actividad",
      selecciona_sector_actividad: "-Selecciona un sector-",
      rango: "Rango de facturación",
      selecciona_rango: "-Selecciona un rango-",
      numero_empleados: "Número de empleados",
      selecciona_numero_empleados: "-Selecciona un rango-",
      anyo_fundacion: "Año de fundación",
      politica_1: "He leído y acepto la ",
      politica_2: "política de privacidad",
      nuevo_contacto_titulo: "Datos del nuevo contacto de gestión",
      anadir_contacto: "Añadir contacto",
      nueva_cuenta_fiscal: "Datos de la cuenta nueva fiscal",
      domicilio_fiscal: "Domicilio Fiscal",
      poblacion: "Población",
      requiere_envio_postal: "Requiere envío postal facturas",
      domicilio_postal: "Domicilio para el envio postal de facturas",
      anadir_cuenta: "Añadir cuenta",
      datos_firmante: "Datos del firmante",
      area_conocimiento: "Área o rama de conocimiento",
      nombre_titulacion: "Nombre de la titulación",
      ano_inicio: "Año de inicio",
      ano_finalizacion: "Año de finalización",
      solicitar_cuenta: "Solicitar cuenta",
      seguir_empresa: "Seguir con los datos de la empresa",
      registrar_empresa: "Registrar Empresa",
      dni_pasaporte_nie: "DNI/NIF/NIE/Pasaporte",
      selecciona_nivel: "-Selecciona un nivel-",
      busca_area: "Busca el área",
      busca_titulacion: "Busca la titulación",
      datos_factura_gastos_gestion:
        "Datos para facturar los gastos de gestión de prácticas extracurriculares",
      factura_proforma: "Factura Proforma",
      tipo_identificacion_facturacion: "Tipo de identificación de facturación",
      cif_identificacion_facturacion: "CIF/Identificación facturación"
    },
    home_empresa: {
      ofertas_practicas: "PROPUESTAS<strong>De prácticas</strong>",
      texto_ofertas_practicas:
        "Consulta las propuestas que has iniciado tanto para Prácticas Académicas como para Formación en Alternancia.",
      nueva_practicas: "PUBLICAR<strong>Nueva propuesta de prácticas",
      nueva_practicas_candidato: "PUBLICAR<strong>Nueva Propuesta de Prácticas o Contrato de Formación en Alternancia con Candidato preseleccionado",
      publicacion_practicas_candidato: "Publica una propuesta de prácticas en la que ya tienes a un estudiante preseleccionado.",
      nueva_practica_formacion: "PUBLICAR<strong>Nueva propuesta de Contrato para la Formación en Alternancia",
      publicar_practicas:
        "Publica propuestas de prácticas, dirigidas a nuestros estudiantes.",
      publicar_practica_formacion:
        "Publica propuestas dirigidas a nuestro estudiantado para la formalización de un Contrato para la Formación en Alternancia.",
      ofertas_empleo: "OFERTAS<strong>De empleo",
      texto_ofertas_empleo:
        "Consulta y gestiona las ofertas de empleo y las candidaturas recibidas.",
      nueva_empleo: "PUBLICAR<strong>Nueva oferta de empleo",
      texto_nueva_empleo:
        "Publica ofertas de empleo, dirigidas a nuestros egresados/as."
    },
    mi_practica: {
      subir_documentacion: "Subir documentación",
      descargar_anexo: "Descargar Anexo Firmado",
      descargar_certificado:
        "Descargar certificado de realización de prácticas",
      descargar_poliza: "Descargar póliza del seguro",
      titulo_practicas:
        "Para poder incorporarte a la realización de estas prácticas es necesario:",
      pagar_creditos: "Pagar los créditos que se van a reconocer.",
      descarga: "Descarga",
      aqui: "aquí",
      documento_pago:
        "el documento de Carta de Pago con la información de cantidades debidas e instrucciones.",
      contratar_poliza:
        "Contratar una póliza de accidentes que te cubra estas prácticas",
      puedes_contratar:
        "Puedes contratar cualquier póliza de seguro, si lo deseas puedes contratar online",
      mensaje_documentos:
        "Una vez tengas <strong>listos</strong> los documentos, por favor <strong>digitalízalos y adjúntalos</strong> a continuación. Revisaremos que son válidos antes de firmar el contrato con la empresa.",
      digitaliza_documentos:
        "Una vez tengas <strong>listo</strong> el documento, por favor <strong>digitalízalo y adjúntalo</strong> a continuación. Revisaremos que es válido antes de firmar el contrato con la empresa.",
      adjuntar_pago: "Adjuntar resguardo de pago",
      adjuntar_seguro: "Adjuntar póliza de seguro",
      descarga_ficheros:
        "Descarga los siguientes ficheros, firmalos y adjuntalos de nuevo.",
      enviar: "Enviar"
    },
    mis_practicas: {
      titulo:
        "En esta sección encontrarás toda la documentación referente a tus prácticas.",
      zero_1:
        "No hay ninguna práctica o documentación de prácticas para mostrar. En caso de duda, por favor",
      zero_2: "contacta con nosotros"
    },
    cambio_password: {
      titulo: "Cambiar contraseña",
      titulo_candidato: "¿Deseas cambiar tu contraseña?",
      contrasena_actual: "Contraseña actual",
      nueva_contrasena: "Nueva Contraseña",
      repetir_contrasena: "Repetir nueva Contraseña"
    },
    cambio_firmante_empresa: {
      titulo:
        "Los datos de Persona con Poderes para la firma de Convenio Marco de Cooperacion Educativa y sus anexos está incompletos, por favor cumpliméntelos a continuación:",
      nombre: "Nombre del firmante",
      apellidos: "Apellidos del firmante",
      email: "Email del firmante",
      dni: "DNI del firmante",
      cargo: "Cargo del firmante"
    },
    guia_orientacion: {
      titulo:
        "A continuación ponemos a tu disposición documentos en relación con tus prácticas o empleo, consejos y buenas prácticas que pueden ser de tu interés.",
      zero: "No hay guias de orientación"
    },
    mi_empresa: {
      intro: {
        cuerpo:
          "Se muestran a continuación los datos principales de su empresa. Si alguno no es correcto, o necesita acceder, corregir, eliminar cualquier detalle de su información.",
        porfavor: "Por favor, ",
        contacte: "contacte con nosotros."
      },
      datos_empresa: "Datos de la empresa"
    },
    mi_perfil: {
      intro: {
        cuerpo:
          "Se muestran a continuación los datos principales de su perfil. Si alguno no es correcto, o necesita acceder, corregir, eliminar cualquier detalle de su información.",
        porfavor: "Por favor, ",
        contacte: "contacte con nosotros."
      },
      datos_empresa: "Datos de la empresa"
    },
    candidaturas_options: {
      aceptar: "Aceptar inscripción",
      rechazar: "Rechazar inscripción",
      motivos_rechazo: "Motivos del rechazo",
      selecciona_motivo: "- Selecciona un motivo de rechazo -",
      rechazar_preinscripcion: "Rechazar preinscripción"
    },
    oferta: {
      intro_editor: " Cumplimenta el formulario a continuación para crear:",
      intro_editor2:
        "Tenga en cuenta que existen una serie de condiciones y limitaciones relativas al desarrollo de prácticas y que además las prácticas extracurriculares llevan asociados costes de gestión. Puede consultar los detalles <a href='/static/docs/acuerdos-de-la-comision-de-practicas-academicas-externas.pdf' target='_blank'><u>aquí</u></a>.",
      tipo_oferta: "Tipo",
      numero_plazas: "Número de plazas",
      experiencia: "Experiencia",
      experiencia_deseable: "Experiencia deseable",
      horario: "Horario",
      fecha_inicio: "Fecha de inicio",
      fecha_fin: "Fecha de finalización",
      tipo_contrato: "Tipo de contrato",
      salario: "Salario",
      creditos: "Créditos superados",
      otras_remuneraciones: "Otras remuneraciones",
      pais: "País",
      poblacion: "Población/Provincia",
      poblacion_only: "Población",
      provincia: "Provincia",
      sector: "Sector",
      area_funcional: "Área funcional",
      sede: "Sede/campus",
      beca: "Beca mensual",
      descripcion_puesto: "Descripción del puesto",
      tarea: "Tarea",
      tutores_disponibles: "Tutores disponibles",
      otras_tareas: "Otras tareas",
      programa_practicas: "Programa de prácticas",
      aviso_programa:
        "Importante consultar para comprobar requisitos obligatorios",
      enlace_inscripcion: "Enlace de inscripción",
      ir_enlace: "Ir al enlace",
      idiomas: "Idiomas",
      anadir_idiomas: "Añadir Idiomas",
      empleo: "Empleo",
      practicas: "Prácticas",
      certificacion: "- Certificación mínima requerida:",
      requerido: "- Requerido",
      estudios_obligatorios: "Estudios obligatorios",
      estudios_deseables: "Estudios deseables",
      requisitos_obligatorios: "Requisitos obligatorios",
      etiquetas: "Etiquetas",
      otros_obligatorios: "Otros obligatorios",
      edad_maxima: "Edad maxima",
      salario_maximo: "Salario Máximo",
      intereses_deseables: "Intereses deseables",
      intereses_obligatorios: "Intereses obligatorios",
      intereses_seleccionados: "Intereses seleccionados",
      competencias_obligatorias: "Competencias obligatorias",
      competencias_seleccionadas: "Competencias seleccionadas",
      paises_nacionalidad_obigatorios: "Paises de Nacionalidad obligatorios",
      paises_residencia_obligatorios: "Paises de Residencia obligatorios",
      provincia_residencia_obligatorios: "Provincia de Residencia obligatorios",
      paises_seleccionados: "Paises seleccionados",
      provincias_seleccionados: "Provincias seleccionadas",
      coche_propio: "Coche propio",
      obligatorio_quest: "¿Obligatorio?",
      carnet_conducir: "Carnet de conducir",
      disponible_extranjero: "Disponible para trabajar en el extranjero",
      disponible_residencia: "Disponible para cambio de residencia",
      trabajando_actualmente: "Trabajando actualmente",
      requisitos_deseables: "Requisitos deseables",
      otros_requisitos_deseables: "Otros Requisitos deseables",
      otros_requisitos_obligatorios: "Otros requisitos obligatorios",
      motivos_exclusion: "Motivos de exclusión",
      competencias_deseables: "Competencias deseables",
      paises_nacionalidad_deseables: "Paises de Nacionalidad deseables",
      paises_residencia_deseables: "Paises de Residencia deseables",
      provincia_residencia_deseables: "Provincia de Residencia deseables",
      programas_informaticos: "Programas informáticos",
      programas_informaticos_deseables: "Programas informáticos deseables",
      documentos_requeridos: "Documentos requeridos",
      documentos: "Documentos",
      marca_documentos:
        "Marca los documentos que deben aportar los candidatos/as.",
      anadir_otro_documento: "Añadir otro tipo de documento",
      nombre_documento_candidato:
        "Nombre del documento a aportar por el candidato",
      inscribirme: "Inscribirme",
      desinscribirme: "Desinscribirme",
      ya_inscrito: "ya estas inscrito",
      cancelar_inscripcion: "Cancelar inscripción",
      buscar_mas_intereses: "Busca más intereses",
      atencion: "¡Atención!",
      tramitar_inscripcion:
        "Para tramitar tu inscripción en esta oferta debes presentar tu candidatura en la web de la empresa ofertante.",
      acceder: "Para acceder",
      pincha_aqui: "pincha aquí.",
      especialidad: "Especialidad",
      estado: "Estado",
      datos_practica: "Datos de la práctica",
      paso_4: "Paso 4 de 4",
      tareas_a_desarrollar: "Tareas a desarrollar",
      horario: "Horario",
      horario_practicas: "Horario de prácticas",
      horario_trabajo: "Horario de trabajo",
      tengo_candidato: "Tengo candidato/a",
      horas_dia: "Horas al día",
      horas_totales: "Horas totales",
      remuneracion: "Remuneración",
      otros_beneficios: "Otros beneficios",
      fecha_inicio: "Fecha de inicio",
      fecha_fin: "Fecha de fin",
      fecha_alta: "Fecha Alta",
      duracion_meses: "Duración (en meses)",
      dedicacion: "Dedicación (% jornada)",
      departamento: "Departamento",
      modalidad: "Modalidad",
      presencialidad: "Presencialidad",
      numero_dias_semana: "Numero de días por semana",
      dias_semana: "Días de la semana",
      vinculado_tfg: "Vinculado a TFG",
      nombre_tfg: "Nombre TFG",
      tutor_tfg: "Tutor/a TFG",
      solicitante: "Solicitante del servicio",
      centro_practicas: "Centro de prácticas",
      n_pedido: "Nº de pedido (si lo requiere)",
      observaciones: "Observaciones",
      direccion: "Dirección",
      nombre_tutor_uni: "Nombre y apellidos del tutor de la Universidad",
      datos_tutor_empresa:
        "Datos de contacto del/la responsable en la empresa",
      nombre: "Nombre",
      apellidos: "Apellidos",
      email: "Email",
      telefono: "Teléfono",
      cargo: "Cargo",
      dni: "DNI",
      titulacion_especialidad: "Titulación o especialidad",
      titulacion: "Titulación",
      selecciona: "-Seleccionar-",
      nombre_oferta: "Nombre / Puesto de trabajo",
      numero_plazas: "Número de plazas",
      experiencia_requerida: "Experiencia requerida",
      experiencia_deseable: "Experiencia deseable",
      opciones_publicacion: "Opciones de publicación",
      url_inscripcion: "URL inscripción empresa",
      candidato_preferido: "Candidato/a preferido",
      datos_realizacion: "Datos de realización de la práctica",
      conocimientos_especificos: "Conocimientos especificos",
      formacion_adquirida: "Formación adquirida",
      seguimiento_previsto: "Seguimiento previsto",
      empresa_destino:
        "Empresa destino (solamente si es oferta de gestora/consultora ETT)",
      datos_tutor:
        "Datos de contacto del/la responsable en la empresa",
      para_estudiantes_ultimo_ano: "Para estudiantes de último año",
      para_perfil_no_universitario: "Para perfil no universitario",
      activo_quest: "¿Activo?",
      ano_promo_maximo: "Año de promoción máximo",
      enviar_quest: "¿Enviar?",
      candidato_leer: "Candidato/a por leer",
      candidatos_leer: "Candidatos/as por leer",
      candidato_total: "Candidato/a en total",
      referencia: "Referència",
      candidatos_total: "Candidatos/as en total",
      ver_detalles: "Ver detalles",
      con_practicas: "- Con prácticas asignadas",
      fecha_caducidad: "Fecha de caducidad",
      buscar_mas_programa: "Busca más programas informáticos",
      programas_elegidos: "Programas informáticos elegidos",
      sin_programas: "Sin programas informáticos especificados",
      selecciona_idioma: "Selecciona un idioma",
      escribe_idioma: "Escribe aquí el idioma",
      indica_certificacion:
        "Indica aquí la certificación o nivel mínimo requerido",
      titulaciones: "Titulaciones",
      requeridas: "requeridas",
      deseables: "valorables",
      a_las_que: "a las que se dirige la oferta",
      nivel: "Centro o Escuela",
      areas: "Áreas",
      cualquier_area: "Cualquier área",
      ninguna_titulacion:
        "Ninguna titulación concuerda con el filtro de nivel indicado.",
      eliminar_todas: "Eliminar todas",
      areas_dirige: "Áreas a las que se dirige la oferta",
      titulaciones_dirige: "Titulaciones a las que se dirige",
      selecciona_titulaciones:
        "Selecciona las titulaciones en el listado de la izquierda",
      cumplimentar:
        "Cumplimentar solo en el caso de que lo considere información relevante para los candidatos/as.",
      tipo_estudios: "Tipo de estudios",
      seleccione_izquierda:
        "Selecciona las áreas en el listado de la izquierda.",
      seleccione_algun_nivel:
        "Seleccione algún nivel para cargar las áreas asociadas",
      especialidad_titulacion: "Especialidad o titulación/es",
      puesto_trabajo: "Puesto de trabajo",
      motivo_rechazo: "Motivo de rechazo",
      ayuda_estudio: "Ayuda al estudio (€ brutos/mes)",
      tutor_empresa: "Tutor de la empresa",
      nombre_tutor: "Nombre del tutor empresa",
      apellidos_tutor: "Apellidos del tutor empresa",
      email_tutor: "Email del tutor empresa",
      telefono_tutor: "Teléfono del tutor empresa",
      cargo_tutor: "Cargo del tutor empresa",
      titulacion_tutor: "Titulación del tutor empresa",
      departamento_tutor: "Departamento del tutor empresa",
      dni_tutor: "DNI del tutor empresa",
      no_definido: "No definido",
      candidatos: "Candidatos/as",
      exportar: "Exportar",
      no_hay_candidatos: "No hay candidatos/as en esta propuesta",
      mas: "más",
      menos: "menos",
      empresa_destino_simple: "Empresa Destino",
      tipo_formacion: "Tipo de formación",
      niveles: "Niveles",
      areas: "Áreas",
      para_estudiantes_ultimo_curso: "Para estudiantes de último curso",
      duplicar_oferta_aviso:
        "Oferta duplicada correctamente ¿Quieres editarla ahora?",
      alumno_validado_uib: "Alumno validado por DOIP UIB",
      condicionespracticas:
        "He leído y estoy de acuerdo con las condiciones. <a target='_blank' href='/uib/condiciones-practicas'>Ver condiciones</a>",
      idioma: "Idioma",
      ofertacerrada:
        "Una oferta cerrada no estará visible ni recibirá nuevos candidatos. ¿Estás seguro de querer cerrar esta oferta?",
      eliminaroferta: "Se va a eliminar la oferta ¿Quieres continuar?",
      ofertaduplicada:
        "Oferta duplicada correctamente ¿Quieres editarla ahora?",
      controlCerraroferta:
        "¿Ha seleccionado a alguno de los candidatos propuestos por DOIP UIB?",
      cumplimentainformacion: "Por favor cumplimente la siguiente información:",
      nombrepersona: "Nombre y apellidos de la persona seleccionada",
      fechainiciocontrato: "Fecha de inicio del contrato",
      tipocontrato: "Tipo de contrato",
      nota_media: "Nota media",
      observaciones: "Observaciones",
      nombre_apellidos_dni: "Nombre, apellidos y DNI",
      ocultar_datos_empresa: "Ocultar datos de la empresa",
      url_informacion_complementaria: "URL para información complementaria",
      fichero_informacion_complementaria: "Fichero información complementaria:"
    },
    filtro_oferta: {
      buscar_nombre: "Busca por nombre del puesto",
      buscar_localizacion: "Busca por localización",
      buscar_titulacion: "Busca por titulación",
      buscar_puesto: "Busca por nombre del puesto",
      filtro_avanzado: "Filtro Avanzado",
      cerrar: "Cerrar",
      fecha_publicacion: "Fecha publicación",
      fecha_inicio_previsa: "Fecha de inicio de práctica prevista",
      fecha_inicio: "Fecha de inicio",
      filtrado_etiqueta: "Filtrado por etiquetas",
      omitir_inscritos: "Omitir ya inscritos",
      oferta_tfg: "Oferta TFG/TFM",
      ofertas_internacional: "Oferta internacional",
      ofertas_cv: "Ofertas que encajan con mi perfil/cv",
      busquedas_guardadas: "Búsquedas guardadas",
      guardar_busqueda: "Guardar búsqueda",
      borrar_filtros: "BORRAR FILTROS",
      ver: "Ver",
      fecha: "Fecha",
      ofertas_tfg: "Oferta TFG/TFM",
      se_han_encontrado: "Se han encontrado",
      introduce_nombre_busqueda: "Introduce el nombre de la búsqueda",
      sobreescribe_existente: "ó sobreescribe una existente",
      selecciona_busqueda: "Selecciona una búsqueda",
      ver_historico: "Ver histórico de ofertas",
      ver_actuales: "Ver ofertas actuales",
      crear_oferta: "CREAR NUEVA",
      historico_ofertas: "Histórico de ofertas",
      no_hay_ofertas: "No hay ofertas coincidentes con tu búsqueda",
      solo_con_candidatos: "Sólo propuestas con candidatos/as sin leer",
      tienen_candidatos: "Tienen candidatos/as",
      caduca_pronto: "Caducan pronto",
      no_leidos: "Solo no leidos"
    },
    popup_confirmacion: {
      recuerda: "¡Recuerda!",
      titulo:
        "Asegúrate de que los datos de tu perfil están actualizados antes de inscribirte a una oferta.",
      actualiza: "Actualízalo pinchando",
      aqui: "aquí.",
      confirma_titulo:
        "Por favor confirma que quieres ser candidato/a en esta oferta.",
      atencion: "¡Atención!",
      necesitamos_anadir:
        "Necesitamos que añadas los siguientes documentos para poder inscribirte a la oferta.",
      url_documento: "URL del documento",
      por_favor_adjunta: "Por favor, adjunta un archivo o url",
      alumnos_master:
        "Los alumnos de máster de 2 años de duración deben tener al menos el 50% de los créditos aprobados, a fecha de inicio de realización de las prácticas, para poder realizarlas. ¿Eres alumno de máster de duración inferior a 2 años, o has superado el 50% de los créditos?"
    },
    popup_pedir_naf: {
      titulo: "¡Atención!",
      subtitulo:
        "Todos los estudiantes deben aportar su Número de Seguridad Social (NSS o NAF) en su perfil. Debes completar:",
      parrafo1:
        "1. El campo Nº Seguridad social: en la sección de Datos personales de tu cv.",
      parrafo2:
        "2. Adjuntar el documento de Comprobante Asignación Número Seguridad Social en la sección Documentación adjunta; apartado disponible al final de tu cv.  ",
      pie: "Accede ya para cumplimentarlo.",
      ir: "IR AHORA"
    },
    popup_encuestas_obligatorias: {
      titulo: "¡Atención!",
      subtitulo:
        "Tiene informes pendientes, debe cumplimentarlos:"
    },
    header: {
      hola: "Hola, ",
      oferta_practicas: "Buscar ofertas de prácticas",
      oferta_practicas_cfa: "Buscar ofertas de formación en alternancia",
      oferta_empleo: "Buscar ofertas de empleo",
      propuesta_practicas: "Nueva propuesta con candidato preseleccionado",
      candidaturas: "Mis candidaturas",
      practicas: "Mis prácticas",
      programas: "Programas",
      encuestas: "Informes",
      eventos: "Eventos",
      mi_cv: "Mi CV",
      guias_orientacion: "Guías Orientación",
      mis_ofertas: "Mis propuestas",
      propuestas_candidato: "Propuestas de prácticas con candidato preseleccionado",
      nueva_oferta: "Nueva propuesta",
      solicitar_cambio_practicas: "Solicitar cambio de prácticas",
      documentacion: "Documentación",
      practicas_asignadas: "Prácticas asignadas",
      solicitudes_practicas_educacion: "Solicitudes prácticas educación",
      encuestas: "Informes",
      mi_empresa: "Mi empresa",
      ayuda: "Ayuda",
      cerrar_sesion: "Cerrar sesión",
      solicitar_baja: "Solicitar baja"
    },
    image_uploader: {
      titulo: "Editar imagen de perfil"
    },
    notificaciones: {
      borrar_todo: "Borrar todo",
      importantes: "Importantes",
      otras_notificaciones: "Otras notificaciones",
      no_notificaciones: "No tienes notificaciones pendientes"
    },
    popup_borrar_cuenta: {
      titulo:
        "¿Desea solicitar la baja del servicio y la supresión de sus datos personales?",
      si: "Sí",
      no: "No"
    },
    popup_restaurar_progreso_encuesta: {
      titulo:
        "Se ha detectado un progreso guardado ¿Desea restaurar el progreso?",
      si: "Sí",
      no: "No"
    },
    popup_faltan_datos_empresa: {
      atencion: "¡Atención!",
      cuerpo_1:
        "Faltan datos obligatorios en tu perfil, por favor accede para completarlos.",
      cuerpo_2:
        "Faltan datos obligatorios en el perfil de tu empresa, por favor accede para completarlos.",
      ir_a_perfil: "Ir a mi Perfil",
      ir_a_empresa: "Ir a Mi empresa"
    },
    popup_datos_personales: {
      atencion: "¡Atención!",
      titulo:
        "Faltan datos obligatorios en tu perfil, por favor accede para completarlos.",
      ir_a_perfil: "Ir a mi Perfil"
    },
    popup_documentacion_alumno: {
      atencion: "¡Atención!",
      cuerpo: "<p>A partir del curso 2023-24, la formalización de la documentación asociada a prácticas académicas, requerirá la <strong>firma con certificado digital</strong> del estudiante.</p><p>Por favor, si no dispone de certificado, debe proceder a su solicitud en la FNMT y posterior instalación. Además del certificado debe disponer de la aplicación de firma Autofirma (<a href='https://autofirma.net/universidad-politecnica-de-madrid/' target='_blank' rel='noopener noreferrer'>https://autofirma.net/universidad-politecnica-de-madrid/</a>)'</p>",
      btn_cta: "Aceptar"
    },
    solicitudes_educacion: {
      titulo:
        "En esta sección encontrarás la información de los estudiantes que han solicitado la realización de prácticas en su centro.",
      zero: "No hay documentación en estos momentos."
    },
    filtro_candidaturas: {
      buscar_nombre: "Busca por nombre del puesto",
      empleo: "Empleo",
      practicas: "Prácticas",
      filtro_avanzado: "Filtro Avanzado",
      cerrar: "Cerrar",
      estado: "Estado",
      ver: "Ver",
      borrar_filtros: "BORRAR FILTROS",
      estas_en: "Estas en",
      zero: "No hay procesos de selección coincidentes con tu búsqueda"
    },
    documentacion: {
      intro: "En esta sección encontrarás la documentación relacionada con las prácticas que se han realizado en tu empresa.",
      intro_alumno: "En esta sección encontrarás la documentación relacionada con tus prácticas.",
      convenio_titulo: "Convenios de colaboración",
      caducado: "(Caducado) -",
      zero_convenio: "Aún no tienes ningún convenio",
      titulo_convenio:
        "Si lo deseas puedes solicitar la tramitación de un nuevo convenio a continuación",
      nuevo_convenio: "Solicitar convenio",
      subir_convenio: "Subir convenio firmado",
      anexos_practicas: "Anexos de prácticas",
      zero_practicas: "Aún no tienes contenido",
      notas_formativas: "Notas formativas",
      en: "en",
      otros_documentos: "Otros documentos asociados a prácticas",
      zero_documentos: "Aún no tienes ningún documento de prácticas",
      otros_documentos_programas: "Otros documentos asociados a programas",
      zero_documentos_practicas:
        "Aún no tienes ningún documento asociado a programas",
      documentos_aportados_empresa: "Otros documentos aportados por la empresa",
      no_documentos_anadidos:
        "No hay documentos añadidos, pulsa en añadir documento para añadirlo",
      anadir_documentacion: "Añadir documentación",
      selecciona_documento: "Selecciona un documento",
      listado_documento: "Listado de documentos",
      otro_tipo_documento: "Otro tipo de documento",
      nombre_documento: "Nombre del documento",
      url_documento: "URL del documento"
    },
    encuestas: {
      titulo: "Informes",
      obligatorias: "Para continuar, responde todas las preguntas obligatorias",
      enviar: "Enviar",
      guardar_progreso: "Guardar progreso",
      pagina: "Página",
      datos_enviados: "Tus datos han sido enviados",
      muchas_gracias: "¡Muchas gracias!",
      iniciar_sesion: "Inicia sesión con tu usuario de perfil",
      empresa: "Empresa",
      candidato: "Candidato",
      usuario: "Usuario",
      contrasena: "Contraseña",
      acceder: "Acceder",
      o: "ó",
      acceder_anonimamente: "Acceder anonimamente",
      contestar_pregunta: "Debes contestar a esta pregunta para continuar",
      formato_numerico: "Solamente se puede indicar número con hasta dos decimales indicados tras coma",
      zero: "No hay informes disponibles",
      titulo: "Informes",
      cuerpo: "Por favor, antes de continuar, responda estos informes",
      no_puedes:
        "No puedes acceder al portal hasta que no hayas contestado las informes obligatorias. Si no deseas responder en este momento, puedes cerrar tu sesión."
    },
    eventos: {
      proximos: "Próximos eventos",
      pasados: "Eventos pasados",
      evento_destacado: "Evento destacado",
      desde: "Desde",
      hasta: "Hasta",
      organizado_por: "Organizado por",
      inscribirse: "Inscribirse",
      inscrito: "Inscrito",
      mas_informacion: "Más información",
      galeria: "Galería de imágenes",
      videos: "Vídeos",
      buscar_localizacion: "Buscar por localización",
      buscar_categoria: "Buscar por categoría",
      buscar_nombre: "Buscar por nombre",
      eventos_pasados: "Eventos ya pasados",
      ver_mas: "Ver más"
    },
    comunicaciones: {
      titulo: "Comunicaciones"
    },
    guias: {
      titulo: "Últimas guías de orientación",
      zero: "No hay guias de orientación"
    },
    ofertas: {
      ultimas_practicas: "Últimas Ofertas de prácticas",
      practicas: "Prácticas",
      ultimas_cfa: "Últimas Ofertas formación en alternancia",
      empleo: "Empleo",
      ofertas: "Ofertas",
      zero_ofertas: "No hay ofertas disponibles.",
      contrato: "Contrato",
      idContrato: "Contrato",
      salario: "Salario",
      areaFuncional: "Área Funcional",
      provincia: "Provincia",
      areasTitulaciones: "Áreas de titulaciones",
      nivelesTitulaciones: "Niveles de titulaciones",
      tiposFormacion: "Tipos de formación",
      tituloPrograma: "Programa",
      area: "Área",
      filtrar_titulacion: "Filtrar por titulación"
    },
    cv: {
      nivel: "Nivel",
      programa_informatico: "Programa informático",
      certificado: "Certificado",
      sin_nivel: "Sin nivel definido",
      presentacion: "Presentación",
      anadir_presentacion: "Para añadir tu presenctación pulsa",
      aqui: "aquí",
      otros_intereses: "Otros intereses",
      tus_interes: "Tus intereses",
      sin_intereses: "Sin intereses especificados",
      escribe_interes: "Escribe algún interes, para comenzar a buscar",
      click_interes: "Haz click sobre el interes, para añadirlo",
      click_cambiar_imagen: "Haz click para cambiar la imagen",
      cambiar_contrasena: "Cambiar contraseña",
      idiomas: "Idiomas",
      idioma: "Idioma",
      sin_idiomas: "Sin idiomas añadidos, pulsa en añadir idioma para añadirlo",
      idioma_obligatorio:
        "El idioma y el nivel son campos obligatorios para añadir un idioma",
      nivel_no_definido: "Nivel no definido",
      nivel: "Nivel",
      nombre_certificado: "Nombre del certificado",
      estancia_extranjero: "Estancia en el extranjero",
      pais_estancia: "País de estancia",
      motivo_estancia: "Motivo de la estancia",
      duracion_meses: "Duración en meses",
      experiencia_profesional: "Experiencia profesional",
      anadir_nueva_experiencia: "Añadir nueva experiencia",
      sin_experiencia: "Sin experiencia",
      nivel_formativo: "Nivel formativo",
      actualidad: "Actualidad",
      puesto: "Titulo del puesto",
      anadir_documento: "Añadir documento",
      sector_empresa: "Sector de la empresa",
      area_actividad_puesto: "Área de actividad del puesto",
      tipo_contrato: "Tipo de contrato",
      subtipo_contrato: "Subtipo de contrato",
      ver_adjunto: "Ver adjunto",
      ver_enlace: "Ver enlace",
      duracion: "Duración",
      fecha_inicio: "Fecha de inicio",
      fecha_fin: "Fecha de fin",
      provincia: "Provincia",
      empresa: "Empresa",
      enlace: "Enlace",
      descripcion_puesto: "Descripción del puesto",
      escribe_descripcion: "Escribe una descripción de las tareas desempeñadas",
      anadir_fichero: "Añadir fichero adjunto",
      adjunto_correctamente: "Archivo adjunto correctamente",
      isla: "Isla",
      programas_informaticos: {
        titulo: "Programas informáticos",
        buscar: "Escribe para buscar",
        zero:
          "No hay programas informáticos añadidos, pulsa en añadir para añadirlos",
        anadir: "Añadir Programa"
      },
      documentacion_adjunta: "Documentación adjunta",
      documentacion_subida: "Documentación subida el",
      no_hay_documentos: "No hay documentos añadidos",
      pulsa_anadir_documentos: ", pulsa en añadir documento para añadirlo",
      anadir_documentacion: "Añadir documentación",
      selecciona_documento: "Selecciona un documento",
      listado_documento: "Listado de documentos",
      otro_tipo_documento: "Otro tipo de documento",
      nombre_documento: "Nombre del documento",
      url_documento: "URL del documento",
      documentacion_privada: "Documentación privada",
      no_documentos:
        "No hay documentos añadidos, pulsa en añadir documento para añadirlo",
      documentacion_ligada: "Documentación ligada a procesos",
      datos_profesionales: "Datos profesionales",
      visitar: "Visitar",
      indica_link_perfil: "Indica link a tu perfil",
      trabajando_actualmente: "Trabajando actualmente",
      permiso_trabajo: "Permiso de trabajo en la UE",
      anos_experiencia: "Años de experiencia",
      sin_experiencia: "Sin experiencia",
      disfrutado_erasmus:
        "He estado de Erasmus o he disfrutado de otra beca de movilidad",
      minima_retribucion: "Mínima retribución",
      brutos_anuales: "/ brutos anuales",
      datos_personales: "Datos personales",
      dni: "DNI",
      fecha_nacimiento: "Fecha de nacimiento",
      genero: "Género",
      femenino: "Femenino",
      masculino: "Masculino",
      email_personal: "Email personal",
      email_estudiante: "Email de estudiante",
      avisos_en_email: "Avisos en el email personal",
      acepta_newsletter: "Acepta newsletter",
      idioma_comunicaciones: "Idioma preferido para las comunicaciones",
      movil: "Movil",
      fijo: "Teléfono fijo",
      direccion_empadronamiento: "Dirección de empadronamiento",
      direccion_actual: "Dirección actual",
      direccion: "Dirección",
      iban: "Nº cuenta IBAN",
      seguridad_social: "Nº Seguridad social",
      pais_nacionalidad: "País de nacionalidad",
      pais_segunda_nacionalidad: "País de segunda nacionalidad",
      provincia_nacimiento: "Provincia de nacimiento",
      provincia: "Provincia",
      lugar_nacimiento: "Lugar de nacimiento",
      discapacidad: "Discapacidad superior al 33%",
      deseo_recibir_comunicaciones:
        "Deseo recibir comunicaciones relacionadas con orientación y servicios relacionados con la formación superior y la UIB:",
      deseo_recibir_info_uni: "Deseo recibir información de la Universidad",
      nombre: "Nombre",
      primer_apellido: "Primer apellido",
      segundo_apellido: "Segundo apellido",
      tipo_identificacion: "Tipo de identificación",
      documento_identidad: "Documento de identidad",
      buscar: "Escribe para buscar",
      cp: "Código Postal",
      pais: "País",
      localidad: "Localidad",
      tipo_via: "Tipo de vía",
      numero: "Número",
      piso: "Piso",
      puerta: "Puerta",
      notas: "Notas",
      datos_academicos: "Datos académicos",
      formacion_complementaria: "Formación complementaria",
      anadir_titulacion: "Añadir nueva titulación",
      complementaria: "complementaria",
      centro: "Centro",
      nivel_academico: "Nivel académico",
      tipo: "Tipo",
      nota: "Nota",
      rama_ensenanza: "Rama de la enseñanza",
      duracion: "Duración",
      actual: "Actual",
      si: "Sí",
      no: "No",
      titulo: "Titulo",
      universidad: "Universidad/Lugar de estudios",
      calificacion: "Calificación",
      calificacion_media: "Calificación media del titulo",
      horas: "Horas",
      ambito: "Ambito de la enseñanza",
      selecciona_tipo: "- Selecciona un tipo -",
      certificacion: "Certificación",
      tienes_cerfificacion: "¿Tienes certificación?",
      competencias_profesionales: "Competencias profesionales",
      tus_competencias: "Tus competencias",
      sin_competencias: "Sin competencias profesionales especificadas",
      solicitar_sesion:
        "¿Necesitas ayuda para cumplimentar este apartado? Puedes solicitar una sesión gratuita de orientación con nosotros pinchando en este <a href='https://content.fueib.org/es/orientacion?hsCtaTracking=b23fd2f4-3b24-4c45-9d90-9fd88b353e09%7Cd6de5ac5-da0e-420e-a24c-dc6ecd1b9dba' target='_blank'>enlace</a> y te ayudaremos.",
      datos_interes: "Datos de interés",
      busqueda_activa_practicas: "Búsqueda activa de prácticas",
      busqueda_activa_empleo: "Búsqueda activa de empleo",
      disponible_extranjero: "Disponible para trabajar en el extranjero",
      permiso_conducir: "Permiso de conducir",
      disponible_cambio_residencia: "Disponible para cambio de residencia",
      coche_propio: "Coche propio",
      disponible_viajar: "Disponible para viajar",
      discapacidad_certificada: "Discapacidad certificada",
      carnet_moto: "Carnet de moto",
      moto_propia: "Moto propia",
      disponibilidad_jornadas: "Disponilidad de jornadas",
      periodo_preferencia_practicas: "Periodo preferencia de prácticas",
      selecciona: "Selecciona",
      anadir_idioma: "Añadir idioma",
      anadir_intereses: "Añadir intereses",
      nuevos_datos_academicos: "Nuevos datos académicos"
    },
    addtitulacion: {
      titulo: "Titulaciones a las que se dirige",
      seleccione_areas: "Seleccione área/s para filtrar titulaciones",
      borrar_areas: "Borrar todas las áreas",
      cualquier_area: "Cualquier área",
      escriba_aqui:
        "Escriba aquí para filtrar el listado de titulaciones a continuación",
      selecciona_titulacion:
        "Seleccione la titulación/es a la/s que se dirige la oferta haciendo clic sobre ella/s",
      ver_titulaciones: "Ver titulaciones de grado",
      listadas: "listadas",
      listados: "listados",
      cualquier_titulacion: "Cualquiera de estas titulaciones de grado",
      ver_titulaciones_postgrado: "Ver titulaciones de postgrado",
      cualquier_titulacion_postgrado:
        "Cualquiera de estas titulaciones de postgrado",
      ver_titulaciones_propio: "Ver titulaciones de Título propio",
      cualquier_titulacion_propio: "Cualquiera de estos títulos propios",
      lo_sentimos:
        "Lo sentimos no se han encontrado titulaciones que coincidan con la búsqueda",
      listado_titulaciones_seleccionadas:
        "Listado de titulaciones seleccionadas",
      eliminar_titulaciones: "Eliminar todas las titulaciones seleccionadas"
    },
    candidato: {
      nuevo: "Nuevo",
      cambiar_estado: "Cambiar estado",
      ver_cv: "Ver CV",
      detalles: "Detalles del candidato/a",
      selecciona_estado: "Selecciona un estado",
      seleccione_motivo:
        "Por favor seleccione el motivo de rechazo del candidato/a.",
      cambio_estado: "Cambio de estado",
      descargar_cv: "Descargar CV"
    },
    cambio_practicas: {
      identifica:
        "Identifica el alumno/a del que solicitan realizar prórroga o variación de sus condiciones de prácticas.",
      alumno: "Alumno",
      selecciona_oferta: "Selecciona la oferta",
      no_practicas:
        "Aún no tienes ninguna práctica sobre la que puedas solicitar un cambio.",
      alumno: "Alumno/a",
      selecciona_alumno: "Selecciona el alumno/a",
      detalles: "Detalles de la modificación",
      tipo_modificacion: "Tipo de modificación",
      selecciona_modificacion: "-Selecciona la modificación-",
      otros_detalles: "Otros detalles",
      adjunto: "Adjunto",
      solicitar_cambio: "Solicitar cambio"
    },
    popup_idioma: {
      titulo: "Vas a cambiar tu preferencia de idioma. ¿Quieres continuar?"
    },
    tiposContrato: {
      "5": "Prácticas",
      "6": "Contrato para la formación en alternancia"
    }
  },
  en: {
    enlaces: {
      actualidad: "/news",
      sala_de_prensa: "/press-room",
      contacto: "/contact",
      trabaja_con_nosotros: "/work-with-us",
      politica_privacidad: "/privacy-policy",
      politica_cookies: "/cookies-policy"
    }
  },
  ca: {
    guardar: "Guardar",
    volver: "< Volver",
    sin_definir: "Sin definir",
    guardar_datos: "Guardar datos",
    cancelar: "Cancelar",
    confirmar: "Confirmar",
    eliminar: "Eliminar",
    aceptar: "Aceptar",
    rechazar: "Rechazar",
    comenzar: "Comenzar",
    cerrar_sesion: "Cerrar sesión",
    ver_menos: "Ver menos",
    ver_mas: "Ver más",
    inicio: "Inicio",
    ver_detalles: "Ver detalles",
    guardar: "Guardar",
    editar: "Editar",
    anadir: "Añadir",
    enviar: "Enviar",
    requerido: "Requerido",
    revisar: "Revisar",
    editar_oferta: "Editar",
    duplicar_oferta: "Duplicar oferta",
    cerrar_oferta: "Cerrar oferta",
    eliminar_oferta: "Elimina oferta",
    ver_como_candidato: "Ver como candidato",
    practicas: "Prácticas",
    empleo: "Empleo",
    ver: "Ver",
    enlaces: {
      politica_privacidad: "/politica-de-privacidad",
      politica_cookies: "/politica-de-cookies",
      login: "/login",
      solicitar_cuenta: "/solicitar-cuenta",
      registroalumno: "/registro",
      encuestas: "/informes",
      encuesta: "/informe",
      eventos: "/eventos",
      eventospublico: "/evento-publico",
      documentacion: "/documentacion",
      guiaOrientacion: "/guias-orientacion",
      ofertas_practicas: "/propuesta-practicas",
      ofertas_empleo: "/ofertas-empleo",
      cv: "/cv",
      vercv: "/ver-cv",
      mis_candidaturas: "/mis-candidaturas",
      mis_practicas: "/mis-practicas",
      orientacion: "/orientacion-laboral",
      propuesta_practicas: "/propuesta-practicas-con-candidato-preseleccionado",
      programapracticasactivos: "/programas-practicas-activos",
      solicitarcambiopracticas: "/solicitar-cambio-practicas",
      subirconvenio: "/subir-convenio-firmado",
      generarnuevoconvenio: "/nuevo-convenio-colaboracion",
      practicaseducacion: "/solicitudes-practicas-educacion",
      nueva_oferta: "/nueva-propuesta",
      editar_oferta: "/editar-propuesta",
      mi_empresa: "/mi-empresa",
      mi_perfil: "/mi-perfil",
      mis_ofertas: "/mis-propuestas",
      mi_oferta: "/propuesta",
      programa_practicas: "/programa-practicas",
      visualizar_oferta: "/visor-oferta",
      restablecer_login: "/restablecer-login",
      restablecer_candidato: "/restablecer-candidato",
      setear_pass: "/establecer-login",
      proteccion_datos: "/proteccion-de-datos",
      acceso_saml: "/acceso",
      logout: "/logout",
      ayuda: "/ayuda",
      condicionespracticasuib: "/uib/condiciones-practicas"
    },
    encabezado: {
      home: "Bienvenid@",
      cv: "Mi currículum",
      cv_view: "Currículum del candidato",
      eventos: "Eventos",
      propuesta_practicas: "Nueva propuesta con candidato preseleccionado",
      politica_privacidad: "Política de privacidad",
      politica_cookies: "Política de cookies",
      login: "Inicio de sesión",
      solicitar_cuenta: "Nueva empresa",
      registro_alumno: "Registro",
      ofertas_practicas: "Listado de ofertas de prácticas",
      ofertas_empleo: "Listado de ofertas de empleo",
      ficha_oferta_alumno_empleo: "Listado de ofertas de empleo",
      ficha_oferta_alumno_practicas: "Listado de ofertas de prácticas",
      mis_candidaturas: "Mis candidaturas",
      mis_practicas: "Mis prácticas",
      encuestas: "Informes",
      orientacion: "Orientación laboral",
      nueva_oferta: "Nueva propuesta",
      editar_oferta: "Editar",
      mi_empresa: "Mi empresa",
      solicitarBaja: "Solicitud de baja",
      mi_perfil: "Mi perfil",
      documentacion: "Documentación",
      guiasOrientacion: "Guías Orientación",
      documentacion_empresa: "Documentación",
      documentacion_alumno: "Mi documentación",
      mis_ofertas: "Mis propuestas",
      mi_oferta: "Mi propuesta",
      ficha_oferta_empresa: "Mi propuesta",
      restablecer_login: "Restablecer Contraseña",
      restablecer_candidato: "Restablecer Contraseña",
      programapracticasactivos: "Programas de prácticas activos",
      setear_pass: "Establecer Contraseña",
      proteccion_datos: "Protección de datos",
      visor_oferta: "Ver como alumno",
      fichaProgramaActivo: "Programas activos",
      solicitudCambioPracticas: "Solicitud cambio de prácticas",
      solicitudesEducacion: "Solicitudes ofertas educación",
      subirConvenioFirmado: "Subir convenio firmado",
      generarNuevoConvenio: "Solicitud de Convenio de Colaboración",
      ayuda: "Ayuda",
      condicionespracticasuib: "Condiciones prácticas",
      factura_proforma: "Factura Proforma"
    },
    ficha_oferta: {
      texto_programa_anadido:
        "Tienes este programa añadido a tu lista de programas informáticos"
    },
    formulario: {
      nombre: "Nombre",
      nombre_apellidos: "Nombre y apellidos",
      apellidos: "Apellidos",
      email: "Email",
      mensaje: "Mensaje",
      fecha_nacimiento: "Fecha de nacimiento",
      dia: "Día",
      mes: "Mes",
      anyo: "Año",
      area_interes: "Área de su interés",
      trabaja_actualmente: "¿Trabaja actualmente?",
      si: "Si",
      no: "No",
      carta_presentacion: "Carta de presentacion",
      meses: {
        Enero: "Enero",
        Febrero: "Febrero",
        Marzo: "Marzo",
        Abril: "Abril",
        Mayo: "Mayo",
        Junio: "Junio",
        Julio: "Julio",
        Agosto: "Agosto",
        Septiembre: "Septiembre",
        Octubre: "Octubre",
        Noviembre: "Noviembre",
        Diciembre: "Diciembre"
      },
      archivo_adjunto: "Adjuntar archivo",
      adjuntar_cv: "Adjuntar CV",
      introduce_mail: "Introduce tu email",
      pais: "País",
      telefono: "Teléfono",
      he_leido: "He leído y acepto la",
      y_acepto: "política de privacidad",
      enviar: "Enviar",
      enviado: "Enviado"
    },
    meses: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ],
    login: {
      iniciar_sesion: "Iniciar sesión",
      acceder: "Acceder",
      email: "Email",
      error_mail: "Por favor, indica tu email para logarte en el portal.",
      contrasena: "Contraseña",
      repetir_contrasena: "Repetir Contraseña",
      contrasena_olvidada: "He olvidado mi contraseña",
      introduce_email: "Introduce tu email",
      email_mal: "El email está mal formado",
      recuperar_pass: "Recuperar mi contraseña",
      aun_no_registrado: "¿Aún no estas registrado/a?",
      acceder_SSO: "ACCEDER SSO UNIVERSIDAD",
      indica_mail:
        "Por favor, indica tu <strong>{{$t('oferta.email')}}</strong> para logarte en el portal.",
      selecciona_empresa:
        "Por favor, selecciona la empresa con la que quieres logarte.",
      titulacion: "Titulación",
      tipo_formacion: "Tipo de formación academica",
      selecciona_formacion: "Selecciona un tipo de formación",
      registrarme: "Registrarme",
      deseo_recibir:
        "Deseo recibir comunicaciones relacionadas con orientación y servicios relacionados con la formación superior y la UIB.",
      popup_rgpd: {
        titulo: "",
        detalle:
          "El acceso, rectificación y cancelación de los datos, así como otros derechos, puede llevarse a cabo según puede ver en el siguiente ",
        enlace: "enlace.",
        boton: "Consiento, acceder"
      },
      restablecer_pass: {
        titulo: "Sigue los pasos para restablecer tu contraseña",
        intro: "La contraseña debe contener al menos 8 caracteres y un numero.",
        guardar: "Guardar"
      },
      seteo_pass: {
        titulo: "Sigue los pasos para establecer tu contraseña",
        intro: "La contraseña debe contener al menos 8 caracteres y un numero.",
        guardar: "Guardar"
      }
    },
    registro: {
      encabezado:
        "Cumplimenta el formulario a continuación para darte de alta en el sistema:",
      datos_usuario: "Datos del usuario de empresa",
      datos_personales: "Datos personales",
      nombre: "Nombre",
      apellidos: "Apellidos",
      DNI: "DNI/NIF/NIE",
      CIF: "CIF de la empresa",
      puesto: "Puesto / Cargo",
      departamento: "Departamento",
      telefono_1: "Teléfono 1",
      telefono_2: "Teléfono 2",
      email: "Email",
      sede: "Sede por defecto",
      cargo: "Cargo",
      idioma: "Idioma preferido de comunicación",
      tipo_contacto: "Tipo de Contacto",
      contrasena: "Contraseña",
      repetir_contrasena: "Repetir Contraseña",
      direccion: "Dirección",
      pais: "País",
      selecciona_pais: "-selecciona un país-",
      provincia: "Provincia",
      selecciona_provincia: "-Selecciona una provincia-",
      localidad: "Localidad",
      selecciona_localidad: "-Selecciona una localidad-",
      direccion: "Dirección",
      direccion_empresa: "Dirección Empresa",
      cp: "Código Postal",
      titulo_2:
        "A continuación introduce los datos de tu empresa para darte de alta en el sistema:",
      anadir_imagen: "Haz click para añadir la imagen",
      autorizar_logo: "Autorizar uso del logo",
      nombre_fiscal: "Nombre fiscal o Razón social",
      nombre_comercial: "Nombre comercial",
      tipo_sociedad: "Tipo de Sociedad",
      selecciona_tipo_sociedad: "-Selecciona tipo de sociedad-",
      tipo_empresa: "Tipo de Empresa",
      privada: "Privada",
      publica: "Pública",
      startup: "Startup",
      eliminar: "Eliminar",
      descripcion: "Descripción",
      si: "Sí",
      no: "No",
      sector: "Sector",
      selecciona_sector: "-Selecciona un sector-",
      otro_sector: "Otro Sector",
      numero_empleados: "Número de empleados",
      selecciona_empleados: "-Selecciona un rango-",
      web: "Web",
      iban: "Número cuenta IBAN",
      descripcion_empresa: "Descripción de la empresa",
      femenino: "Femenino",
      masculino: "Masculino",
      telefono: "Teléfono",
      centrosTrabajo: "Centro de trabajo o sucursales",
      firmante: {
        titulo:
          "A continuación introduce los datos del representante legal de la empresa que firmará los convenios:",
        nombre: "Nombre del firmante",
        apellidos: "Apellidos del firmante",
        email: "Email del firmante",
        dni: "DNI del firmante",
        cargo: "Cargo del firmante",
        telefono: "Teléfono"
      },
      envio_facturas: {
        titulo: "Dirección envío de facturas",
        titulo_2: "Dirección de facturación"
      },
      anadir_direccion: "Añadir nueva dirección de facturación",
      perfil_sectorial: "Perfil sectorial",
      sector_actividad: "Sector de actividad",
      selecciona_sector_actividad: "-Selecciona un sector-",
      rango: "Rango de facturación",
      selecciona_rango: "-Selecciona un rango-",
      numero_empleados: "Número de empleados",
      selecciona_numero_empleados: "-Selecciona un rango-",
      anyo_fundacion: "Año de fundación",
      politica_1: "He leído y acepto la ",
      politica_2: "política de privacidad",
      nuevo_contacto_titulo: "Datos del nuevo contacto de gestión",
      anadir_contacto: "Añadir contacto",
      nueva_cuenta_fiscal: "Datos de la cuenta nueva fiscal",
      domicilio_fiscal: "Domicilio Fiscal",
      poblacion: "Población",
      requiere_envio_postal: "Requiere envío postal facturas",
      domicilio_postal: "Domicilio para el envio postal de facturas",
      anadir_cuenta: "Añadir cuenta",
      datos_firmante: "Datos del firmante",
      area_conocimiento: "Área o rama de conocimiento",
      nombre_titulacion: "Nombre de la titulación",
      ano_inicio: "Año de inicio",
      ano_finalizacion: "Año de finalización",
      solicitar_cuenta: "Solicitar cuenta",
      seguir_empresa: "Seguir con los datos de la empresa",
      registrar_empresa: "Registrar Empresa",
      dni_pasaporte_nie: "DNI/NIF/NIE/Pasaporte",
      selecciona_nivel: "-Selecciona un nivel-",
      busca_area: "Busca el área",
      busca_titulacion: "Busca la titulación",
      datos_factura_gastos_gestion:
        "Datos para facturar los gastos de gestión por prácticas extracurriculares de alumnos"
    },
    home_empresa: {
      ofertas_practicas: "PROPUESTAS<strong>De prácticas</strong>",
      texto_ofertas_practicas:
        "Consulta y gestiona las propuestas de prácticas y las candidaturas recibidas.",
      nueva_practicas: "PUBLICAR<strong>Nueva propuesta de prácticas",
      nueva_practica_formacion: "PUBLICAR<strong>Nueva propuesta de Contrato para la Formación en Alternancia",
      publicar_practicas:
        "Publica propuestas de prácticas, dirigidas a nuestros estudiantes.",
      publicar_practica_formacion:
        "Publica propuestas dirigidas a nuestro estudiantado para la formalización de un Contrato para la Formación en Alternancia.",
      ofertas_empleo: "OFERTAS<strong>De empleo",
      texto_ofertas_empleo:
        "Consulta y gestiona las ofertas de empleo y las candidaturas recibidas.",
      nueva_empleo: "PUBLICAR<strong>Nueva oferta de empleo",
      texto_nueva_empleo:
        "Publica ofertas de empleo, dirigidas a nuestros egresados/as."
    },
    mi_practica: {
      subir_documentacion: "Subir documentación",
      descargar_anexo: "Descargar Anexo Firmado",
      descargar_certificado:
        "Descargar certificado de realización de prácticas",
      descargar_poliza: "Descargar póliza del seguro",
      titulo_practicas:
        "Para poder incorporarte a la realización de estas prácticas es necesario:",
      pagar_creditos: "Pagar los créditos que se van a reconocer.",
      descarga: "Descarga",
      aqui: "aquí",
      documento_pago:
        "el documento de Carta de Pago con la información de cantidades debidas e instrucciones.",
      contratar_poliza:
        "Contratar una póliza de accidentes que te cubra estas prácticas",
      puedes_contratar:
        "Puedes contratar cualquier póliza de seguro, si lo deseas puedes contratar online",
      mensaje_documentos:
        "Una vez tengas <strong>listos</strong> los documentos, por favor <strong>digitalízalos y adjúntalos</strong> a continuación. Revisaremos que son válidos antes de firmar el contrato con la empresa.",
      digitaliza_documentos:
        "Una vez tengas <strong>listo</strong> el documento, por favor <strong>digitalízalo y adjúntalo</strong> a continuación. Revisaremos que es válido antes de firmar el contrato con la empresa.",
      adjuntar_pago: "Adjuntar resguardo de pago",
      adjuntar_seguro: "Adjuntar póliza de seguro",
      descarga_ficheros:
        "Descarga los siguientes ficheros, firmalos y adjuntalos de nuevo.",
      enviar: "Enviar"
    },
    mis_practicas: {
      titulo:
        "En esta sección encontrarás toda la documentación referente a tus prácticas.",
      zero_1:
        "No hay ninguna práctica o documentación de prácticas para mostrar. En caso de duda, por favor",
      zero_2: "contacta con nosotros"
    },
    cambio_password: {
      titulo: "Cambiar contraseña",
      titulo_candidato: "¿Deseas cambiar tu contraseña?",
      contrasena_actual: "Contraseña actual",
      nueva_contrasena: "Nueva Contraseña",
      repetir_contrasena: "Repetir nueva Contraseña"
    },
    cambio_firmante_empresa: {
      titulo:
        "Los datos de Persona con Poderes para la firma de Convenio Marco de Cooperacion Educativa y sus anexos está incompletos, por favor cumpliméntelos a continuación:",
      nombre: "Nombre del firmante",
      apellidos: "Apellidos del firmante",
      email: "Email del firmante",
      dni: "DNI del firmante",
      cargo: "Cargo del firmante"
    },
    guia_orientacion: {
      titulo:
        "A continuación ponemos a tu disposición documentos en relación con tus prácticas o empleo, consejos y buenas prácticas que pueden ser de tu interés.",
      zero: "No hay guias de orientación"
    },
    mi_empresa: {
      intro: {
        cuerpo:
          "Se muestran a continuación los datos principales de su empresa. Si alguno no es correcto, o necesita acceder, corregir, eliminar cualquier detalle de su información.",
        porfavor: "Por favor, ",
        contacte: "contacte con nosotros."
      },
      datos_empresa: "Datos de la empresa"
    },
    mi_perfil: {
      intro: {
        cuerpo:
          "Se muestran a continuación los datos principales de su perfil. Si alguno no es correcto, o necesita acceder, corregir, eliminar cualquier detalle de su información.",
        porfavor: "Por favor, ",
        contacte: "contacte con nosotros."
      },
      datos_empresa: "Datos de la empresa"
    },
    candidaturas_options: {
      aceptar: "Aceptar inscripción",
      rechazar: "Rechazar inscripción",
      motivos_rechazo: "Motivos del rechazo",
      selecciona_motivo: "- Selecciona un motivo de rechazo -",
      rechazar_preinscripcion: "Rechazar preinscripción"
    },
    oferta: {
      intro_editor: " Cumplimenta el formulario a continuación para crear:",
      intro_editor2:
        " Tenga en cuenta que existen una serie de condiciones y limitaciones relativas al desarrollo de prácticas y que además las prácticas extracurriculares llevan asociados costes de gestión. Puede consultar los detalles <a href='/static/docs/acuerdos-de-la-comision-de-practicas-academicas-externas.pdf' target='_blank'><u>aquí</u></a>.",
      tipo_oferta: "Tipo",
      numero_plazas: "Número de plazas",
      experiencia: "Experiencia",
      experiencia_deseable: "Experiencia deseable",
      horario: "Horario",
      fecha_inicio: "Fecha de inicio",
      fecha_fin: "Fecha de finalización",
      tipo_contrato: "Tipo de contrato",
      salario: "Salario",
      creditos: "Créditos superados",
      otras_remuneraciones: "Otras remuneraciones",
      pais: "País",
      poblacion: "Población/Provincia",
      poblacion_only: "Población",
      provincia: "Provincia",
      sector: "Sector",
      area_funcional: "Área funcional",
      sede: "Sede/campus",
      beca: "Beca mensual",
      descripcion_puesto: "Descripción del puesto",
      tarea: "Tarea",
      tutores_disponibles: "Tutores disponibles",
      otras_tareas: "Otras tareas",
      programa_practicas: "Programa de prácticas",
      aviso_programa:
        "Importante consultar para comprobar requisitos obligatorios",
      enlace_inscripcion: "Enlace de inscripción",
      ir_enlace: "Ir al enlace",
      idiomas: "Idiomas",
      anadir_idiomas: "Añadir Idiomas",
      empleo: "Empleo",
      practicas: "Prácticas",
      certificacion: "- Certificación mínima requerida:",
      requerido: "- Requerido",
      estudios_obligatorios: "Estudios obligatorios",
      estudios_deseables: "Estudios deseables",
      requisitos_obligatorios: "Requisitos obligatorios",
      etiquetas: "Etiquetas",
      otros_obligatorios: "Otros obligatorios",
      edad_maxima: "Edad maxima",
      salario_maximo: "Salario Máximo",
      intereses_deseables: "Intereses deseables",
      intereses_obligatorios: "Intereses obligatorios",
      intereses_seleccionados: "Intereses seleccionados",
      competencias_obligatorias: "Competencias obligatorias",
      competencias_seleccionadas: "Competencias seleccionadas",
      paises_nacionalidad_obigatorios: "Paises de Nacionalidad obligatorios",
      paises_residencia_obligatorios: "Paises de Residencia obligatorios",
      provincia_residencia_obligatorios: "Provincia de Residencia obligatorios",
      paises_seleccionados: "Paises seleccionados",
      provincias_seleccionados: "Provincias seleccionadas",
      coche_propio: "Coche propio",
      obligatorio_quest: "¿Obligatorio?",
      carnet_conducir: "Carnet de conducir",
      disponible_extranjero: "Disponible para trabajar en el extranjero",
      disponible_residencia: "Disponible para cambio de residencia",
      trabajando_actualmente: "Trabajando actualmente",
      requisitos_deseables: "Requisitos deseables",
      otros_requisitos_deseables: "Otros Requisitos deseables",
      otros_requisitos_obligatorios: "Otros requisitos obligatorios",
      motivos_exclusion: "Motivos de exclusión",
      competencias_deseables: "Competencias deseables",
      paises_nacionalidad_deseables: "Paises de Nacionalidad deseables",
      paises_residencia_deseables: "Paises de Residencia deseables",
      provincia_residencia_deseables: "Provincia de Residencia deseables",
      programas_informaticos: "Programas informáticos",
      programas_informaticos_deseables: "Programas informáticos deseables",
      documentos_requeridos: "Documentos requeridos",
      documentos: "Documentos",
      marca_documentos:
        "Marca los documentos que deben aportar los candidatos/as.",
      anadir_otro_documento: "Añadir otro tipo de documento",
      nombre_documento_candidato:
        "Nombre del documento a aportar por el candidato",
      inscribirme: "Inscribirme",
      desinscribirme: "Desinscribirme",
      ya_inscrito: "ya estas inscrito",
      cancelar_inscripcion: "Cancelar inscripción",
      buscar_mas_intereses: "Busca más intereses",
      atencion: "¡Atención!",
      tramitar_inscripcion:
        "Para tramitar tu inscripción en esta oferta debes presentar tu candidatura en la web de la empresa ofertante.",
      acceder: "Para acceder",
      pincha_aqui: "pincha aquí.",
      especialidad: "Especialidad",
      estado: "Estado",
      datos_practica: "Datos de la práctica",
      paso_4: "Paso 4 de 4",
      tareas_a_desarrollar: "Tareas a desarrollar",
      horario: "Horario",
      horario_practicas: "Horario de prácticas",
      horario_trabajo: "Horario de trabajo",
      tengo_candidato: "Tengo candidato/a",
      horas_dia: "Horas al día",
      remuneracion: "Remuneración",
      otros_beneficios: "Otros beneficios",
      fecha_inicio: "Fecha de inicio",
      fecha_fin: "Fecha de fin",
      fecha_alta: "Fecha Alta",
      duracion_meses: "Duración (en meses)",
      dedicacion: "Dedicación (% jornada)",
      departamento: "Departamento",
      modalidad: "Modalidad",
      numero_dias_semana: "Numero de días por semana",
      dias_semana: "Días de la semana",
      vinculado_tfg: "Vinculado a TFG",
      nombre_tfg: "Nombre TFG",
      tutor_tfg: "Tutor/a TFG",
      solicitante: "Solicitante del servicio",
      centro_practicas: "Centro de prácticas",
      n_pedido: "Nº de pedido (si lo requiere)",
      observaciones: "Observaciones",
      direccion: "Dirección",
      nombre_tutor_uni: "Nombre y apellidos del tutor de la Universidad",
      datos_tutor_empresa:
        "Datos de contacto del/la responsable en la empresa",
      nombre: "Nombre",
      apellidos: "Apellidos",
      email: "Email",
      telefono: "Teléfono",
      cargo: "Cargo",
      dni: "DNI",
      titulacion_especialidad: "Titulación o especialidad",
      titulacion: "Titulación",
      selecciona: "-Seleccionar-",
      nombre_oferta: "Nombre / Puesto de trabajo",
      numero_plazas: "Número de plazas",
      experiencia_requerida: "Experiencia requerida",
      experiencia_deseable: "Experiencia deseable",
      opciones_publicacion: "Opciones de publicación",
      url_inscripcion: "URL inscripción empresa",
      candidato_preferido: "Candidato/a preferido",
      datos_realizacion: "Datos de realización de la práctica",
      conocimientos_especificos: "Conocimientos especificos",
      formacion_adquirida: "Formación adquirida",
      seguimiento_previsto: "Seguimiento previsto",
      empresa_destino:
        "Empresa destino (solamente si es oferta de gestora/consultora ETT)",
      datos_tutor:
        "Datos de contacto del/la responsable en la empresa",
      para_estudiantes_ultimo_ano: "Para estudiantes de último año",
      para_perfil_no_universitario: "Para perfil no universitario",
      activo_quest: "¿Activo?",
      ano_promo_maximo: "Año de promoción máximo",
      enviar_quest: "¿Enviar?",
      candidato_leer: "Candidato/a por leer",
      candidatos_leer: "Candidatos/as por leer",
      candidato_total: "Candidato/a en total",
      referencia: "Referència",
      candidatos_total: "Candidatos/as en total",
      ver_detalles: "Ver detalles",
      con_practicas: "- Con prácticas asignadas",
      fecha_caducidad: "Fecha de caducidad",
      buscar_mas_programa: "Busca más programas informáticos",
      programas_elegidos: "Programas informáticos elegidos",
      sin_programas: "Sin programas informáticos especificados",
      selecciona_idioma: "Selecciona un idioma",
      escribe_idioma: "Escribe aquí el idioma",
      indica_certificacion:
        "Indica aquí la certificación o nivel mínimo requerido",
      titulaciones: "Titulaciones",
      requeridas: "requeridas",
      deseables: "valorables",
      a_las_que: "a las que se dirige la oferta",
      nivel: "Centro o Escuela",
      areas: "Áreas",
      cualquier_area: "Cualquier área",
      ninguna_titulacion:
        "Ninguna titulación concuerda con el filtro de nivel indicado.",
      eliminar_todas: "Eliminar todas",
      areas_dirige: "Áreas a las que se dirige la oferta",
      titulaciones_dirige: "Titulaciones a las que se dirige",
      selecciona_titulaciones:
        "Selecciona las titulaciones en el listado de la izquierda",
      cumplimentar:
        "Cumplimentar solo en el caso de que lo considere información relevante para los candidatos/as.",
      tipo_estudios: "Tipo de estudios",
      seleccione_izquierda:
        "Selecciona las áreas en el listado de la izquierda.",
      seleccione_algun_nivel:
        "Seleccione algún nivel para cargar las áreas asociadas",
      especialidad_titulacion: "Especialidad o titulación/es",
      puesto_trabajo: "Puesto de trabajo",
      motivo_rechazo: "Motivo de rechazo",
      ayuda_estudio: "Ayuda al estudio (€ brutos/mes)",
      tutor_empresa: "Tutor de la empresa",
      nombre_tutor: "Nombre del tutor empresa",
      apellidos_tutor: "Apellidos del tutor empresa",
      email_tutor: "Email del tutor empresa",
      telefono_tutor: "Teléfono del tutor empresa",
      cargo_tutor: "Cargo del tutor empresa",
      titulacion_tutor: "Titulación del tutor empresa",
      departamento_tutor: "Departamento del tutor empresa",
      dni_tutor: "DNI del tutor empresa",
      no_definido: "No definido",
      candidatos: "Candidatos/as",
      exportar: "Exportar",
      no_hay_candidatos: "No hay candidatos/as en esta propuesta",
      mas: "más",
      menos: "menos",
      empresa_destino_simple: "Empresa Destino",
      tipo_formacion: "Tipo de formación",
      niveles: "Niveles",
      areas: "Áreas",
      para_estudiantes_ultimo_curso: "Para estudiantes de último curso",
      duplicar_oferta_aviso:
        "Oferta duplicada correctamente ¿Quieres editarla ahora?",
      alumno_validado_uib: "Alumno validado por DOIP UIB",
      condicionespracticas:
        "He leído y estoy de acuerdo con las condiciones. <a target='_blank' href='/uib/condiciones-practicas'>Ver condiciones</a>",
      idioma: "Idioma",
      ofertacerrada:
        "Una oferta cerrada no estará visible ni recibirá nuevos candidatos. ¿Estás seguro de querer cerrar esta oferta?",
      eliminaroferta: "Se va a eliminar la oferta ¿Quieres continuar?",
      ofertaduplicada:
        "Oferta duplicada correctamente ¿Quieres editarla ahora?",
      controlCerraroferta:
        "¿Ha seleccionado a alguno de los candidatos propuestos por DOIP UIB?",
      cumplimentainformacion: "Por favor cumplimente la siguiente información:",
      nombrepersona: "Nombre y apellidos de la persona seleccionada",
      fechainiciocontrato: "Fecha de inicio del contrato",
      tipocontrato: "Tipo de contrato",
      nota_media: "Nota media",
      observaciones: "Observaciones",
      nombre_apellidos_dni: "Nombre, apellidos y DNI",
      ocultar_datos_empresa: "Ocultar datos de la empresa",
      url_informacion_complementaria: "URL para información complementaria",
      fichero_informacion_complementaria: "Fichero información complementaria:"
    },
    filtro_oferta: {
      buscar_nombre: "Busca por nombre del puesto",
      buscar_localizacion: "Busca por localización",
      buscar_titulacion: "Busca por titulación",
      buscar_puesto: "Busca por nombre del puesto",
      filtro_avanzado: "Filtro Avanzado",
      cerrar: "Cerrar",
      fecha_publicacion: "Fecha publicación",
      fecha_inicio_previsa: "Fecha de inicio de práctica prevista",
      fecha_inicio: "Fecha de inicio",
      filtrado_etiqueta: "Filtrado por etiquetas",
      omitir_inscritos: "Omitir ya inscritos",
      oferta_tfg: "Oferta TFG/TFM",
      ofertas_internacional: "Oferta internacional",
      ofertas_cv: "Ofertas que encajan con mi perfil/cv",
      busquedas_guardadas: "Búsquedas guardadas",
      guardar_busqueda: "Guardar búsqueda",
      borrar_filtros: "BORRAR FILTROS",
      ver: "Ver",
      fecha: "Fecha",
      ofertas_tfg: "Oferta TFG/TFM",
      se_han_encontrado: "Se han encontrado",
      introduce_nombre_busqueda: "Introduce el nombre de la búsqueda",
      sobreescribe_existente: "ó sobreescribe una existente",
      selecciona_busqueda: "Selecciona una búsqueda",
      ver_historico: "Ver histórico de ofertas",
      ver_actuales: "Ver ofertas actuales",
      crear_oferta: "CREAR NUEVA",
      historico_ofertas: "Histórico de ofertas",
      no_hay_ofertas: "No hay ofertas coincidentes con tu búsqueda",
      solo_con_candidatos: "Sólo propuestas con candidatos/as sin leer",
      tienen_candidatos: "Tienen candidatos/as",
      caduca_pronto: "Caducan pronto",
      no_leidos: "Solo no leidos"
    },
    popup_confirmacion: {
      recuerda: "¡Recuerda!",
      titulo:
        "Asegúrate de que los datos de tu perfil están actualizados antes de inscribirte a una oferta.",
      actualiza: "Actualízalo pinchando",
      aqui: "aquí.",
      confirma_titulo:
        "Por favor confirma que quieres ser candidato/a en esta oferta.",
      atencion: "¡Atención!",
      necesitamos_anadir:
        "Necesitamos que añadas los siguientes documentos para poder inscribirte a la oferta.",
      url_documento: "URL del documento",
      por_favor_adjunta: "Por favor, adjunta un archivo o url",
      alumnos_master:
        "Los alumnos de máster de 2 años de duración deben tener al menos el 50% de los créditos aprobados, a fecha de inicio de realización de las prácticas, para poder realizarlas. ¿Eres alumno de máster de duración inferior a 2 años, o has superado el 50% de los créditos?"
    },
    header: {
      hola: "Hola, ",
      oferta_practicas: "Buscar ofertas de prácticas",
      oferta_empleo: "Buscar ofertas de empleo",
      propuesta_practicas: "Nueva propuesta con candidato preseleccionado",
      candidaturas: "Mis candidaturas",
      practicas: "Mis prácticas",
      programas: "Programas",
      encuestas: "Informes",
      eventos: "Eventos",
      mi_cv: "Mi CV",
      guias_orientacion: "Guías Orientación",
      mis_ofertas: "Mis propuestas",
      propuestas_candidato: "Propuestas de prácticas con candidato preseleccionado",
      nueva_oferta: "Nueva propuesta",
      solicitar_cambio_practicas: "Solicitar cambio de prácticas",
      documentacion: "Documentación",
      solicitudes_practicas_educacion: "Solicitudes prácticas educación",
      encuestas: "Informes",
      mi_empresa: "Mi empresa",
      ayuda: "Ayuda",
      cerrar_sesion: "Cerrar sesión",
      solicitar_baja: "Solicitar baja"
    },
    image_uploader: {
      titulo: "Editar imagen de perfil"
    },
    notificaciones: {
      borrar_todo: "Borrar todo",
      importantes: "Importantes",
      otras_notificaciones: "Otras notificaciones",
      no_notificaciones: "No tienes notificaciones pendientes"
    },
    popup_borrar_cuenta: {
      titulo:
        "¿Desea solicitar la baja del servicio y la supresión de sus datos personales?",
      si: "Sí",
      no: "No"
    },
    popup_restaurar_progreso_encuesta: {
      titulo:
        "Se ha detectado un progreso guardado ¿Desea restaurar el progreso?",
      si: "Sí",
      no: "No"
    },
    popup_faltan_datos_empresa: {
      atencion: "¡Atención!",
      cuerpo_1:
        "Faltan datos obligatorios en tu perfil, por favor accede para completarlos.",
      cuerpo_2:
        "Faltan datos obligatorios en el perfil de tu empresa, por favor accede para completarlos.",
      ir_a_perfil: "Ir a mi Perfil",
      ir_a_empresa: "Ir a Mi empresa"
    },
    popup_datos_personales: {
      atencion: "¡Atención!",
      titulo:
        "Faltan datos obligatorios en tu perfil, por favor accede para completarlos.",
      ir_a_perfil: "Ir a mi Perfil"
    },
    solicitudes_educacion: {
      titulo:
        "En esta sección encontrarás la información de los estudiantes que han solicitado la realización de prácticas en su centro.",
      zero: "No hay documentación en estos momentos."
    },
    filtro_candidaturas: {
      buscar_nombre: "Busca por nombre del puesto",
      empleo: "Empleo",
      practicas: "Prácticas",
      filtro_avanzado: "Filtro Avanzado",
      cerrar: "Cerrar",
      estado: "Estado",
      ver: "Ver",
      borrar_filtros: "BORRAR FILTROS",
      estas_en: "Estas en",
      zero: "No hay procesos de selección coincidentes con tu búsqueda"
    },
    documentacion: {
      intro: "En esta sección encontrarás la documentación relacionada con las prácticas que se han realizado en tu empresa.",
      intro_alumno: "En esta sección encontrarás la documentación relacionada con tus prácticas.",
      convenio_titulo: "Convenios de colaboración",
      caducado: "(Caducado) -",
      zero_convenio: "Aún no tienes ningún convenio",
      titulo_convenio:
        "Si lo deseas puedes solicitar la tramitación de un nuevo convenio a continuación",
      nuevo_convenio: "Solicitar convenio",
      subir_convenio: "Subir convenio firmado",
      anexos_practicas: "Anexos de prácticas",
      zero_practicas: "Aún no tienes contenido",
      notas_formativas: "Notas formativas",
      en: "en",
      otros_documentos: "Otros documentos asociados a prácticas",
      zero_documentos: "Aún no tienes ningún documento de prácticas",
      otros_documentos_programas: "Otros documentos asociados a programas",
      zero_documentos_practicas:
        "Aún no tienes ningún documento asociado a programas",
      documentos_aportados_empresa: "Otros documentos aportados por la empresa",
      no_documentos_anadidos:
        "No hay documentos añadidos, pulsa en añadir documento para añadirlo",
      anadir_documentacion: "Añadir documentación",
      selecciona_documento: "Selecciona un documento",
      listado_documento: "Listado de documentos",
      otro_tipo_documento: "Otro tipo de documento",
      nombre_documento: "Nombre del documento",
      url_documento: "URL del documento"
    },
    encuestas: {
      titulo: "Informes",
      obligatorias: "Para continuar, responde todas las preguntas obligatorias",
      enviar: "Enviar",
      guardar_progreso: "Guardar progreso",
      pagina: "Página",
      datos_enviados: "Tus datos han sido enviados",
      muchas_gracias: "¡Muchas gracias!",
      iniciar_sesion: "Inicia sesión con tu usuario de perfil",
      empresa: "Empresa",
      candidato: "Candidato",
      usuario: "Usuario",
      contrasena: "Contraseña",
      acceder: "Acceder",
      o: "ó",
      acceder_anonimamente: "Acceder anonimamente",
      contestar_pregunta: "Debes contestar a esta pregunta para continuar",
      formato_numerico: "Solamente se puede indicar número con hasta dos decimales indicados tras coma",
      zero: "No hay informes disponibles",
      titulo: "Informes",
      cuerpo: "Por favor, antes de continuar, responda estos informes",
      no_puedes:
        "No puedes acceder al portal hasta que no hayas contestado las informes obligatorias. Si no deseas responder en este momento, puedes cerrar tu sesión."
    },
    eventos: {
      proximos: "Próximos eventos",
      pasados: "Eventos pasados",
      evento_destacado: "Evento destacado",
      desde: "Desde",
      hasta: "Hasta",
      organizado_por: "Organizado por",
      inscribirse: "Inscribirse",
      inscrito: "Inscrito",
      mas_informacion: "Más información",
      galeria: "Galería de imágenes",
      videos: "Vídeos",
      buscar_localizacion: "Buscar por localización",
      buscar_categoria: "Buscar por categoría",
      buscar_nombre: "Buscar por nombre",
      eventos_pasados: "Eventos ya pasados",
      ver_mas: "Ver más"
    },
    comunicaciones: {
      titulo: "Comunicaciones"
    },
    guias: {
      titulo: "Últimas guías de orientación",
      zero: "No hay guias de orientación"
    },
    ofertas: {
      ultimas_practicas: "Últimas Ofertas de prácticas",
      practicas: "Prácticas",
      ultimas_empleo: "Últimas Ofertas de empleo",
      empleo: "Empleo",
      ofertas: "Ofertas",
      zero_ofertas: "No hay ofertas disponibles.",
      contrato: "Contrato",
      idContrato: "Contrato",
      salario: "Salario",
      areaFuncional: "Área Funcional",
      provincia: "Provincia",
      areasTitulaciones: "Áreas de titulaciones",
      nivelesTitulaciones: "Niveles de titulaciones",
      tiposFormacion: "Tipos de formación",
      tituloPrograma: "Programa",
      area: "Área",
      filtrar_titulacion: "Filtrar por titulación"
    },
    cv: {
      nivel: "Nivel",
      programa_informatico: "Programa informático",
      certificado: "Certificado",
      sin_nivel: "Sin nivel definido",
      presentacion: "Presentación",
      anadir_presentacion: "Para añadir tu presenctación pulsa",
      aqui: "aquí",
      otros_intereses: "Otros intereses",
      tus_interes: "Tus intereses",
      sin_intereses: "Sin intereses especificados",
      escribe_interes: "Escribe algún interes, para comenzar a buscar",
      click_interes: "Haz click sobre el interes, para añadirlo",
      click_cambiar_imagen: "Haz click para cambiar la imagen",
      cambiar_contrasena: "Cambiar contraseña",
      idiomas: "Idiomas",
      idioma: "Idioma",
      sin_idiomas: "Sin idiomas añadidos, pulsa en añadir idioma para añadirlo",
      idioma_obligatorio:
        "El idioma y el nivel son campos obligatorios para añadir un idioma",
      nivel_no_definido: "Nivel no definido",
      nivel: "Nivel",
      nombre_certificado: "Nombre del certificado",
      estancia_extranjero: "Estancia en el extranjero",
      pais_estancia: "País de estancia",
      motivo_estancia: "Motivo de la estancia",
      duracion_meses: "Duración en meses",
      experiencia_profesional: "Experiencia profesional",
      anadir_nueva_experiencia: "Añadir nueva experiencia",
      sin_experiencia: "Sin experiencia",
      nivel_formativo: "Nivel formativo",
      actualidad: "Actualidad",
      puesto: "Titulo del puesto",
      anadir_documento: "Añadir documento",
      sector_empresa: "Sector de la empresa",
      area_actividad_puesto: "Área de actividad del puesto",
      tipo_contrato: "Tipo de contrato",
      subtipo_contrato: "Subtipo de contrato",
      ver_adjunto: "Ver adjunto",
      ver_enlace: "Ver enlace",
      duracion: "Duración",
      fecha_inicio: "Fecha de inicio",
      fecha_fin: "Fecha de fin",
      provincia: "Provincia",
      empresa: "Empresa",
      enlace: "Enlace",
      descripcion_puesto: "Descripción del puesto",
      escribe_descripcion: "Escribe una descripción de las tareas desempeñadas",
      anadir_fichero: "Añadir fichero adjunto",
      adjunto_correctamente: "Archivo adjunto correctamente",
      isla: "Isla",
      programas_informaticos: {
        titulo: "Programas informáticos",
        buscar: "Escribe para buscar",
        zero:
          "No hay programas informáticos añadidos, pulsa en añadir para añadirlos",
        anadir: "Añadir Programa"
      },
      documentacion_adjunta: "Documentación adjunta",
      documentacion_subida: "Documentación subida el",
      no_hay_documentos: "No hay documentos añadidos",
      pulsa_anadir_documentos: ", pulsa en añadir documento para añadirlo",
      anadir_documentacion: "Añadir documentación",
      selecciona_documento: "Selecciona un documento",
      listado_documento: "Listado de documentos",
      otro_tipo_documento: "Otro tipo de documento",
      nombre_documento: "Nombre del documento",
      url_documento: "URL del documento",
      documentacion_privada: "Documentación privada",
      no_documentos:
        "No hay documentos añadidos, pulsa en añadir documento para añadirlo",
      documentacion_ligada: "Documentación ligada a procesos",
      datos_profesionales: "Datos profesionales",
      visitar: "Visitar",
      indica_link_perfil: "Indica link a tu perfil",
      trabajando_actualmente: "Trabajando actualmente",
      permiso_trabajo: "Permiso de trabajo en la UE",
      anos_experiencia: "Años de experiencia",
      sin_experiencia: "Sin experiencia",
      disfrutado_erasmus:
        "He estado de Erasmus o he disfrutado de otra beca de movilidad",
      minima_retribucion: "Mínima retribución",
      brutos_anuales: "/ brutos anuales",
      datos_personales: "Datos personales",
      dni: "DNI",
      fecha_nacimiento: "Fecha de nacimiento",
      genero: "Género",
      femenino: "Femenino",
      masculino: "Masculino",
      email_personal: "Email personal",
      email_estudiante: "Email de estudiante",
      avisos_en_email: "Avisos en el email personal",
      acepta_newsletter: "Acepta newsletter",
      idioma_comunicaciones: "Idioma preferido para las comunicaciones",
      movil: "Movil",
      fijo: "Teléfono fijo",
      direccion_empadronamiento: "Dirección de empadronamiento",
      direccion_actual: "Dirección actual",
      direccion: "Dirección",
      iban: "Nº cuenta IBAN",
      seguridad_social: "Nº Seguridad social",
      pais_nacionalidad: "País de nacionalidad",
      pais_segunda_nacionalidad: "País de segunda nacionalidad",
      provincia_nacimiento: "Provincia de nacimiento",
      provincia: "Provincia",
      lugar_nacimiento: "Lugar de nacimiento",
      discapacidad: "Discapacidad superior al 33%",
      deseo_recibir_comunicaciones:
        "Deseo recibir comunicaciones relacionadas con orientación y servicios relacionados con la formación superior y la UIB:",
      deseo_recibir_info_uni: "Deseo recibir información de la Universidad",
      nombre: "Nombre",
      primer_apellido: "Primer apellido",
      segundo_apellido: "Segundo apellido",
      tipo_identificacion: "Tipo de identificación",
      documento_identidad: "Documento de identidad",
      buscar: "Escribe para buscar",
      cp: "Código Postal",
      pais: "País",
      localidad: "Localidad",
      tipo_via: "Tipo de vía",
      numero: "Número",
      piso: "Piso",
      puerta: "Puerta",
      notas: "Notas",
      datos_academicos: "Datos académicos",
      formacion_complementaria: "Formación complementaria",
      anadir_titulacion: "Añadir nueva titulación",
      complementaria: "complementaria",
      centro: "Centro",
      nivel_academico: "Nivel académico",
      tipo: "Tipo",
      nota: "Nota",
      rama_ensenanza: "Rama de la enseñanza",
      duracion: "Duración",
      actual: "Actual",
      si: "Sí",
      no: "No",
      titulo: "Titulo",
      universidad: "Universidad/Lugar de estudios",
      calificacion: "Calificación",
      calificacion_media: "Calificación media del titulo",
      horas: "Horas",
      ambito: "Ambito de la enseñanza",
      selecciona_tipo: "- Selecciona un tipo -",
      certificacion: "Certificación",
      tienes_cerfificacion: "¿Tienes certificación?",
      competencias_profesionales: "Competencias profesionales",
      tus_competencias: "Tus competencias",
      sin_competencias: "Sin competencias profesionales especificadas",
      solicitar_sesion:
        "¿Necesitas ayuda para cumplimentar este apartado? Puedes solicitar una sesión gratuita de orientación con nosotros pinchando en este <a href='https://content.fueib.org/es/orientacion?hsCtaTracking=b23fd2f4-3b24-4c45-9d90-9fd88b353e09%7Cd6de5ac5-da0e-420e-a24c-dc6ecd1b9dba' target='_blank'>enlace</a> y te ayudaremos.",
      datos_interes: "Datos de interés",
      busqueda_activa_practicas: "Búsqueda activa de prácticas",
      busqueda_activa_empleo: "Búsqueda activa de empleo",
      disponible_extranjero: "Disponible para trabajar en el extranjero",
      permiso_conducir: "Permiso de conducir",
      disponible_cambio_residencia: "Disponible para cambio de residencia",
      coche_propio: "Coche propio",
      disponible_viajar: "Disponible para viajar",
      discapacidad_certificada: "Discapacidad certificada",
      carnet_moto: "Carnet de moto",
      moto_propia: "Moto propia",
      disponibilidad_jornadas: "Disponilidad de jornadas",
      periodo_preferencia_practicas: "Periodo preferencia de prácticas",
      selecciona: "Selecciona",
      anadir_idioma: "Añadir idioma",
      anadir_intereses: "Añadir intereses",
      nuevos_datos_academicos: "Nuevos datos académicos"
    },
    addtitulacion: {
      titulo: "Titulaciones a las que se dirige",
      seleccione_areas: "Seleccione área/s para filtrar titulaciones",
      borrar_areas: "Borrar todas las áreas",
      cualquier_area: "Cualquier área",
      escriba_aqui:
        "Escriba aquí para filtrar el listado de titulaciones a continuación",
      selecciona_titulacion:
        "Seleccione la titulación/es a la/s que se dirige la oferta haciendo clic sobre ella/s",
      ver_titulaciones: "Ver titulaciones de grado",
      listadas: "listadas",
      listados: "listados",
      cualquier_titulacion: "Cualquiera de estas titulaciones de grado",
      ver_titulaciones_postgrado: "Ver titulaciones de postgrado",
      cualquier_titulacion_postgrado:
        "Cualquiera de estas titulaciones de postgrado",
      ver_titulaciones_propio: "Ver titulaciones de Título propio",
      cualquier_titulacion_propio: "Cualquiera de estos títulos propios",
      lo_sentimos:
        "Lo sentimos no se han encontrado titulaciones que coincidan con la búsqueda",
      listado_titulaciones_seleccionadas:
        "Listado de titulaciones seleccionadas",
      eliminar_titulaciones: "Eliminar todas las titulaciones seleccionadas"
    },
    candidato: {
      nuevo: "Nuevo",
      cambiar_estado: "Cambiar estado",
      ver_cv: "Ver CV",
      detalles: "Detalles del candidato/a",
      selecciona_estado: "Selecciona un estado",
      seleccione_motivo:
        "Por favor seleccione el motivo de rechazo del candidato/a.",
      cambio_estado: "Cambio de estado",
      descargar_cv: "Descargar CV"
    },
    cambio_practicas: {
      identifica:
        "Identifica el alumno/a del que solicitan realizar prórroga o variación de sus condiciones de prácticas.",
      alumno: "Alumno",
      selecciona_oferta: "Selecciona la oferta",
      no_practicas:
        "Aún no tienes ninguna práctica sobre la que puedas solicitar un cambio.",
      alumno: "Alumno/a",
      selecciona_alumno: "Selecciona el alumno/a",
      detalles: "Detalles de la modificación",
      tipo_modificacion: "Tipo de modificación",
      selecciona_modificacion: "-Selecciona la modificación-",
      otros_detalles: "Otros detalles",
      adjunto: "Adjunto",
      solicitar_cambio: "Solicitar cambio"
    },
    popup_idioma: {
      titulo: "Vas a cambiar tu preferencia de idioma. ¿Quieres continuar?"
    }
  }
};



// WEBPACK FOOTER //
// ./src/translations/index.js